const RATINGS = {
  positive: "POSITIVE",
  negative: "NEGATIVE",
};

const RATING_CONTENT_TYPES = {
  summary: "SUMMARY",
  transcript: "TRANSCRIPT",
};

const RATING_RESOURCE_TYPES = {
  profile: "PROFILE",
  interviewResponse: "INTERVIEW_RESPONSE",
};

export { RATING_CONTENT_TYPES, RATING_RESOURCE_TYPES };

export default RATINGS;
